import { create, v, w } from '@dojo/framework/core/vdom';
import { icache } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
import { IconButton } from './iconButton';
import { HeadingSelect } from './headingSelect';
import { Link } from './link';
import css from '../css/editor.m.css';
import { subscribe } from '@holmescorp/pub-sub';
const factory = create({
    icache,
    theme
}).properties();
const defaults = {
    bold: 'bold',
    italic: 'italic',
    underline: 'underline',
    'list-ol': 'insertorderedList',
    'list-ul': 'insertunorderedList',
    indent: 'indent',
    outdent: 'outdent',
    undo: 'undo',
    redo: 'redo'
};
export const EditorToolbar = factory(({ middleware: { icache, theme } }) => {
    const range = icache.getOrSet('range', new Range());
    const getInitialValue = (range) => {
        var _a;
        const selection = document.getSelection();
        selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
        selection === null || selection === void 0 ? void 0 : selection.addRange(range);
        const container = selection === null || selection === void 0 ? void 0 : selection.anchorNode;
        const initialValue = (container === null || container === void 0 ? void 0 : container.nodeType) === 3 ? (_a = container === null || container === void 0 ? void 0 : container.parentNode) === null || _a === void 0 ? void 0 : _a.nodeName.toLowerCase() : 'div';
        return initialValue;
    };
    subscribe('current:selection', (topic, range) => {
        icache.set('range', range);
    });
    const buttons = Object.keys(defaults).map((iconName) => {
        return icache.getOrSet(iconName, w(IconButton, {
            iconName,
            onClick: () => {
                var _a;
                const command = defaults[iconName];
                document.execCommand(command, false, undefined);
                (_a = document.getElementById('editor')) === null || _a === void 0 ? void 0 : _a.focus();
            }
        }));
    });
    const { toolbar } = theme.classes(css);
    const disabled = range.collapsed;
    const title = disabled ? 'Please make a Selection' : '';
    return v('div', { classes: [toolbar] }, [
        w(HeadingSelect, {
            value: getInitialValue(range),
            disabled,
            title,
            onValue: (value) => {
                var _a;
                document.execCommand('formatBlock', false, value);
                (_a = document.getElementById('editor')) === null || _a === void 0 ? void 0 : _a.focus();
            }
        }),
        ...buttons,
        w(Link, {
            disabled,
            title,
            onLink: (url, target) => {
                var _a;
                const selection = document.getSelection();
                if (selection && range instanceof Range) {
                    selection.removeAllRanges();
                    selection.addRange(range);
                }
                const a = document.createElement('a');
                a.href = url;
                a.target = target;
                a.title = a.outerHTML;
                a.text = selection ? selection.toString() : url;
                document.execCommand('delete', false);
                document.execCommand('insertHTML', false, a.outerHTML);
                (_a = document.getElementById('editor')) === null || _a === void 0 ? void 0 : _a.focus();
            }
        }),
        w(IconButton, {
            iconName: 'unlink',
            disabled,
            title,
            onClick: () => {
                var _a;
                document.execCommand('unlink', false, undefined);
                (_a = document.getElementById('editor')) === null || _a === void 0 ? void 0 : _a.focus();
            }
        })
    ]);
});
export default EditorToolbar;
